import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { headerSty, contentSty } from "../table-styles";
import { UsersComponentProps, UsersDataProps } from "../../interface/users";
import { limitToSeven } from "../../utils/url-id";
import { Pagination } from "../Pagination";

export default function PermittedUsers({
  usersList,
  paginationState,
  setPaginationState,
  isLoading,
}: UsersComponentProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const headStyles = { ...headerSty, color: theme.palette.neutral.main };
  const contentStyles = { ...contentSty };
  
  return (
    <>
    <TableContainer
      component={Paper}
      sx={{
        my: 1,
        px: 2,
        py: 3,
        width: "96%",
        mx: "auto",
        background: "#FAFBFC",
        borderRadius: 2,
        boxShadow: "none",
        minHeight: 350,
      }}
    >
      <Table
        sx={{ width: "98%", mx: "auto" }}
        size="small"
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>ID</TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>Email</TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>Is Verified</TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>Gender</TableCell>
            <TableCell sx={{ ...headStyles, textAlign: "left" }}>
              Role
            </TableCell>
          
          </TableRow>
        </TableHead>
        <TableBody>
          {!isLoading &&
            usersList.map((row: UsersDataProps) => (
              <TableRow
                onClick={() => navigate(`/users/${row?._id}`)}
                key={row?._id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell
                  sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                  component="th"
                  scope="row"
                >
                  {limitToSeven(row._id)}
                </TableCell>
                <TableCell
                  sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                >
                  {row.email ?? "-"}
                </TableCell>
                <TableCell
                  sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                >
                  {row.isVerified?.toString() ?? "-"}
                </TableCell>
                <TableCell
                  sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                >
                  {row.gender ?? "-"}
                </TableCell>
                <TableCell
                  sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                >
                  {row.role ?? "-"}
                </TableCell>
                <TableCell
                  sx={{ ...contentStyles, textAlign: "left", padding: "12px" }}
                >
                  {/* {row.permission} */}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {usersList?.length === 0 && !isLoading && (
        <Box
          sx={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, color: theme.palette.neutral.main }}
          >
            No Users Available.
          </Typography>
        </Box>
      )}
      {isLoading && (
        <Box sx={{ width: "96%", mx: "auto" }}>
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={"100%"}
            height={60}
            sx={{ my: 2 }}
          />
        </Box>
      )}
     
    </TableContainer>
    <Pagination
        paginationState={paginationState}
        setPaginationState={setPaginationState}
      />
    </>
  );
}
